module.exports = __webpack_public_path__ + "img/17a001-18.8afc39fc.png";